import tw, { styled } from 'twin.macro'

export const BannerWrapper = styled.div`
  ${tw`grid grid-cols-1 grid-rows-1`}
`

export const BannerTextContent = styled.aside`
  ${tw`[grid-column:1_/_span_1] [grid-row:1_/_span_1] self-center`}
  ${tw`max-w-4xl xl:max-w-3xl 2xl:max-w-4xl px-6 mx-auto w-full`}
  ${tw`text-2xl leading-normal md:[font-size:2rem] xl:[font-size:2.25rem] 2xl:[font-size:2.65rem] 2xl:leading-relaxed mx-auto w-full`}
  ${tw`py-6 [font-family:Lora] font-medium text-white`}

  a {
    ${tw`underline !text-gold-500`}
  }
`

export const BannerBackground = styled.img`
  ${tw`[grid-column:1_/_span_1] [grid-row:1_/_span_1] w-full h-full`}
`
